import { Controller } from "@hotwired/stimulus";

function cssVar(name, fallback) {
  if (typeof getComputedStyle === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

function formatBytes(n) {
  if (!Number.isFinite(n) || n < 0) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  const d = i === 0 ? 0 : v < 10 ? 1 : 0;
  return `${v.toFixed(d)} ${units[i]}`;
}

export default class extends Controller {
  static values = {
    usedBytes: Number,
    limitBytes: Number,
  };

  connect() {
    if (typeof ApexCharts === "undefined") {
      this.element.innerHTML =
        '<p class="text-warning small mb-0">Gráfico indisponível.</p>';
      return;
    }

    const used = Math.max(0, this.usedBytesValue || 0);
    const limit = Math.max(1, this.limitBytesValue || 1);
    const pctOfPlan = Math.min(999, Math.round((used / limit) * 1000) / 10);

    const danger = cssVar("--bs-danger", "#ff3e1d");
    const success = cssVar("--bs-success", "#71dd37");
    const dangerDark = "#c62828";
    const labelMuted = cssVar("--bs-secondary-color", "#8592a3");
    const heading = cssVar("--bs-heading-color", "#566a7f");

    let series;
    let colors;
    let labels;

    if (used <= limit) {
      const free = Math.max(0, limit - used);
      series = [used, free];
      colors = [danger, success];
      labels = ["Em uso (DB)", "Disponível no plano (exemplo)"];
    } else {
      const excess = used - limit;
      series = [limit, excess];
      colors = [danger, dangerDark];
      labels = ["Até o limite do plano (ex.)", "Além do limite (ex.)"];
    }

    this.chart = new ApexCharts(this.element, {
      chart: {
        type: "donut",
        height: 280,
        fontFamily: "inherit",
        toolbar: { show: false },
      },
      labels,
      series,
      colors,
      plotOptions: {
        pie: {
          donut: {
            size: "72%",
            labels: {
              show: true,
              name: { show: true, fontSize: "11px", color: labelMuted },
              value: {
                show: true,
                fontSize: "22px",
                fontWeight: 600,
                color: heading,
                formatter: () => formatBytes(used),
              },
              total: {
                show: true,
                showAlways: true,
                label: "Uso vs. plano (ex.)",
                fontSize: "11px",
                color: labelMuted,
                formatter: () => `${pctOfPlan}%`,
              },
            },
          },
        },
      },
      dataLabels: { enabled: false },
      legend: {
        position: "bottom",
        fontSize: "12px",
        markers: { width: 8, height: 8, radius: 2 },
      },
      stroke: { width: 0 },
      tooltip: {
        y: {
          formatter: (val) => formatBytes(val),
        },
      },
    });
    this.chart.render();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
